import { decodeFolderId } from "pages/Folders/helpers/folderUrlId";

export const IN_FILTER_REGEX = /in:"[^"]*"\s*/g;
export const IN_FILTER_CAPTURE_REGEX = /in:"([^"]*)"/;

export const ALL_FOLDERS_ROUTE = "__search";

// folders that never scope a search: searching there means "all folders"
const UNSCOPED_FOLDERS = ["inbox", ALL_FOLDERS_ROUTE];

export { decodeFolderId };

export const normalizeSearchQuery = query => {
  if (!query || query === "null") {
    return "";
  }

  const value = decodeFolderId(query).trim();

  try {
    return decodeURIComponent(value).trim();
  } catch (error) {
    return value;
  }
};

export const stripFolderFilter = query => {
  return normalizeSearchQuery(query).replace(IN_FILTER_REGEX, "").trim();
};

export const getFolderFilter = query => {
  const match = normalizeSearchQuery(query).match(IN_FILTER_CAPTURE_REGEX);
  return match?.[1] || null;
};

export const isAllFolderScope = folderId => {
  const decoded = decodeFolderId(folderId).toLowerCase();
  return !decoded || UNSCOPED_FOLDERS.includes(decoded);
};

// route + url query -> the query that is sent to the api layer, the single
// place where the search scope is decided. idempotent.
export const buildScopedQuery = (folderId, query) => {
  const normalized = normalizeSearchQuery(query);

  if (!normalized) {
    return null;
  }

  if (isAllFolderScope(folderId)) {
    return normalized;
  }

  return `in:"${decodeFolderId(folderId)}" ${stripFolderFilter(
    normalized
  )}`.trim();
};

export const createSearchString = values => {
  const params = new URLSearchParams();

  Object.entries(values).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      params.set(key, value);
    }
  });

  const search = params.toString();
  return search ? `?${search}` : "";
};
